export const ACTION = {
  update: "update",
  create: "create",
  delete: "delete",
  submit: "submit",
  view: "view",
  setting: "setting",
  save: "save",
  search: "search",
  select: "select",
  changePage: "changePage",
  upload: "upload",
  query: "query",
  saveContact: "saveContact"
};
